import {
  // REDUX ACTIONS
  UPDATE_DETAILS_STATIC_FETCH_STATUS,
  UPDATE_DETAILS_HERMES_FETCH_STATUS,
  UPDATE_DETAILS_STATIC_DATA,
  UPDATE_DETAILS_HERMES_DATA,
  UPDATE_CURRENT_ROOM,
  UPDATE_DETAILS_CONFIG,
  UPDATE_UGC_IMAGES,
  UPDATE_ABOUT_PROPERTY,

  // TYPE SCRIPT TYPES
  DetailStaticShape,
  DetailsHermesShape,
  SelectedRoomDataType,
  IUpdate_Details_Config_Action,
  RESET_DETAILS_DATA,
  IResetDetailsData,
  ACTION_UPDATE_HOTEL_POLICY_LIST,
  UPDATE_HOTEL_POLICY_LIST,
  UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
  ACTION_UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
  ACTION_UPDATE_HOTEL_POLICY_ERROR,
  UPDATE_HOTEL_POLICY_ERROR,
  DetailsStateShape,
  FetchStatusType,
  ACTION_UPDATE_HOTEL_POLICY_FETCH_STATUS,
  UPDATE_HOTEL_POLICY_FETCH_STATUS,

  // SIMILAR HOTELS
  UPDATE_SIMILAR_HOTELS_DATA,
  UPDATE_SIMILAR_HOTELS_ERROR,
  UPDATE_SIMILAR_HOTELS_FETCH_STATUS,
} from './types';
import {HotelPolicyDataTypes} from '../utils/fetch-hotel-policy';

// 🐨 no use typing voyager data because dynamic data wouldn't be type checked
// 🐨 leaving it as 'any' for now, and will progressively add the types for
// front end engineer's convenience
export const updateDetailsStaticData = (staticData: DetailStaticShape) => {
  return {
    type: UPDATE_DETAILS_STATIC_DATA,
    payload: {
      staticData,
    },
  };
};

export const updateUgcImages = actionData => {
  return {
    type: UPDATE_UGC_IMAGES,
    actionData,
  };
};

export const updateAboutPropertyData = actionData => {
  return {
    type: UPDATE_ABOUT_PROPERTY,
    actionData,
  };
};

// 🐨 leaving it as 'any' for now, and will progressively add the types for
// front end engineer's convenience
export const updateDetailsHermesData = (hermesData: DetailsHermesShape) => {
  return {
    type: UPDATE_DETAILS_HERMES_DATA,
    payload: {
      hermesData,
    },
  };
};

export const updateDetailsStaticFetchStatus = ({isLoading}: {isLoading: boolean}) => {
  return {
    type: UPDATE_DETAILS_STATIC_FETCH_STATUS,
    payload: {
      isLoading,
    },
  };
};

export const updateCurrentRoom = (roomData: SelectedRoomDataType) => {
  return {
    type: UPDATE_CURRENT_ROOM,
    payload: {
      roomData,
    },
  };
};

export const updateDetailsHermesFetchStatus = ({isLoading}: {isLoading: boolean}) => {
  return {
    type: UPDATE_DETAILS_HERMES_FETCH_STATUS,
    payload: {
      isLoading,
    },
  };
};

export const updateDetailsPageConfigAction = (
  actionData: IUpdate_Details_Config_Action['actionData'],
): IUpdate_Details_Config_Action => {
  return {
    type: UPDATE_DETAILS_CONFIG,
    actionData,
  };
};

export const resetDetailsDataAction = (): IResetDetailsData => {
  return {
    type: RESET_DETAILS_DATA,
  };
};

export const updateHotelPolicyFetchStatus = (
  status: FetchStatusType,
): ACTION_UPDATE_HOTEL_POLICY_FETCH_STATUS => {
  return {
    type: UPDATE_HOTEL_POLICY_FETCH_STATUS,
    payload: {
      hotelPolicyFetchStatus: status,
    },
  };
};

export const updateHotelPolicyList = (
  hotelPolicyList: DetailsStateShape['hotelPolicyData']['hotelPolicyList'],
): ACTION_UPDATE_HOTEL_POLICY_LIST => {
  return {
    type: UPDATE_HOTEL_POLICY_LIST,
    payload: {
      hotelPolicyList,
    },
  };
};

export const updateHotelPolicyAdditionalData = (
  hotelPolicyAdditionalData: DetailsStateShape['hotelPolicyData']['hotelPolicyAdditionalData'],
): ACTION_UPDATE_HOTEL_POLICY_ADDITIONAL_DATA => {
  return {
    type: UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
    payload: {
      hotelPolicyAdditionalData,
    },
  };
};

export const updateHotelPolicyError = (error: Error): ACTION_UPDATE_HOTEL_POLICY_ERROR => {
  return {
    type: UPDATE_HOTEL_POLICY_ERROR,
    payload: {
      hotelPolicyError: error,
    },
  };
};

export const updateSimilarHotels = ({list, cityMetaInfo}) => {
  return {
    type: UPDATE_SIMILAR_HOTELS_DATA,
    payload: {
      list,
      cityMetaInfo,
    },
  };
};

export const updateSimilarHotelsError = (error: Error) => {
  return {
    type: UPDATE_SIMILAR_HOTELS_ERROR,
    payload: {
      error,
    },
  };
};

export const updateSimilarHotelsFetchStatus = (fetchStatus: FetchStatusType) => {
  return {
    type: UPDATE_SIMILAR_HOTELS_FETCH_STATUS,
    payload: {
      fetchStatus,
    },
  };
};
// const estrela = {
//   id: '7022552177697192106',
//   hermes: `https://hermes.goibibo.com/hotels/v11/detail/price/v3/8717279093827200968/20200109/20200110/1-2-0/7022552177697192106?ibp=&im=true&slot=false`,
// };

// const palmarinha = {
//   id: '6359680374160639334',
//   hermes: `https://hermes.goibibo.com/hotels/v11/detail/price/v3/8717279093827200968/20200109/20200110/1-2-0/6359680374160639334?ibp=&im=true&slot=false`,
// };

// const mango = {
//   id: '8533417782733308249',
//   hermes: `https://hermes.goibibo.com/hotels/v11/detail/price/v3/6771549831164675055/20200109/20200110/1-2-0/8533417782733308249?ibp=v3&im=true&slot=false`,
// };

// const selected = palmarinha;
